module.exports = __webpack_public_path__ + "assets/img/qywh_img3.e38c15b4.png";